const TRACK_STORAGE_KEY = "track_storage_key";
const EXPIRATION_DAYS = 365; // 1년

interface TrackItem {
  productSlug: string;
  createdAt: number;
}

class ProductRecommendationTracker {
  private isExpired = (item: TrackItem): boolean => {
    const expirationMs = EXPIRATION_DAYS * 24 * 60 * 60 * 1000;
    return Date.now() - item.createdAt > expirationMs;
  };

  private loadItems = (): TrackItem[] => {
    if (typeof window === "undefined") return [];
    const data = localStorage.getItem(TRACK_STORAGE_KEY);
    if (!data) return [];
    return JSON.parse(data).filter((item: TrackItem) => !this.isExpired(item));
  };

  private saveItems = (items: TrackItem[]) => {
    if (typeof window === "undefined") return;
    localStorage.setItem(TRACK_STORAGE_KEY, JSON.stringify(items));
  };

  private getIndexBySlug = (items: TrackItem[], productSlug: string) => {
    return items.findIndex((item) => item.productSlug === productSlug);
  };

  public track = (productSlug: string | string[]) => {
    if (typeof window === "undefined") return;

    const slugs = Array.isArray(productSlug) ? productSlug : [productSlug];
    const items = this.loadItems();

    slugs.forEach((slug) => {
      const index = this.getIndexBySlug(items, slug);
      if (index >= 0) {
        items[index].createdAt = Date.now();
      } else {
        items.push({ productSlug: slug, createdAt: Date.now() });
      }
    });

    this.saveItems(items);
  };

  public untrack = (productSlug: string | string[]): boolean => {
    if (typeof window === "undefined") return false;
    const items = this.loadItems();
    const slugs = Array.isArray(productSlug) ? productSlug : [productSlug];

    let hasRemoved = false;
    slugs.forEach((slug) => {
      const index = this.getIndexBySlug(items, slug);
      if (index >= 0) {
        items.splice(index, 1);
        hasRemoved = true;
      }
    });

    if (hasRemoved) {
      this.saveItems(items);
    }
    return hasRemoved;
  };

  public getAll = (): TrackItem[] => {
    return this.loadItems();
  };

  public clear = () => {
    if (typeof window === "undefined") return;
    localStorage.removeItem(TRACK_STORAGE_KEY);
  };
}

export const ProductTracker = new ProductRecommendationTracker();
